module.exports = __webpack_public_path__ + "media/svg-new/setting-v5-3fb3cc98.svg";